import store from "@/store";
// eslint-disable-next-line no-unused-vars
import sponsorshipCaseTabSelector, {
  overview,
  guide,
  candidate,
  case_profile,
  documents,
  costs,
  online_application,
} from "../sponsorship";
// Base chunks

const Login = () =>
  import(
    /* webpackChunkName: "base" */
    "@/views/Login.vue"
  );

const NotFound = () =>
  import(
    /* webpackChunkName: "base" */
    "@/views/NotFound.vue"
  );

const Documents = () =>
  import(
    /* webpackChunkName: "base" */
    "@/views/Documents.vue"
  );

const Account = () =>
  import(
    /* webpackChunkName: "base" */
    "@/views/Account.vue"
  );

const Company = () =>
  import(
    /* webpackChunkName: "base" */
    "@/views/Company.vue"
  );

const Cases = () =>
  import(
    /* webpackChunkName: "base" */
    "@/views/Cases.vue"
  );

const SponsorshipCase = () =>
  import(
    /* webpackChunkName: "base" */
    "@/components/Cases/Sponsorship"
  );

const CasesTable = () =>
  import(
    /* webpackChunkName: "base" */
    "@/components/Cases"
  );

const baseRoutes = [
  {
    path: "/",
    name: "home",
    meta: {
      auth: true,
      title: "Home",
    },
  },

  {
    path: "/documents",
    name: "documents",
    component: Documents,
    meta: {
      auth: true,
      title: "Documents",
    },
  },

  {
    path: "/account",
    name: "account",
    component: Account,
    meta: {
      auth: true,
      title: "Account",
    },
  },

  {
    path: "/company",
    name: "company-profile",
    component: Company,
    meta: {
      auth: true,
      title: "Company profile",
    },
  },

  {
    path: "/cases",
    component: Cases,
    meta: {
      auth: true,
      title: "Cases",
    },
    beforeEnter: (to, from, next) => {
      store.dispatch("usercase/refreshUsercaseList").then(() => next());
    },
    children: [
      {
        path: "",
        name: "cases",
        component: CasesTable,
        meta: {
          auth: true,
          title: "Cases",
        },
      },

      {
        path: ":case_id(\\d+)/sponsorship",
        name: "case",
        component: SponsorshipCase,
        props: true,
        meta: {
          auth: true,
          title: "Sponsor Licence",
        },
        children: [
          {
            path: "overview",
            components: {
              default: SponsorshipCase,
              tab: overview,
            },
            meta: {
              tab: "overview",
              auth: true,
              title: "Sponsor licence",
            },
            beforeEnter: (to, from, next) => {
              if (store.getters["usercase/currentUsercase"])
                store.dispatch("usercase/sponsorship/refreshOverview");
              next();
            },
          },

          {
            path: "guide",
            components: {
              default: SponsorshipCase,
              tab: guide,
            },
            meta: {
              auth: true,
              title: "Sponsor licence",
            },
          },

          {
            path: "case_profile",
            components: {
              default: SponsorshipCase,
              tab: case_profile,
            },
            meta: {
              auth: true,
              title: "Sponsor licence",
            },
          },

          {
            path: "costs",
            components: {
              default: SponsorshipCase,
              tab: costs,
            },
            meta: {
              auth: true,
              title: "Sponsor licence",
            },
          },

          {
            path: "candidate",
            components: {
              default: SponsorshipCase,
              tab: candidate,
            },
            meta: {
              auth: true,
              title: "Sponsor licence",
            },
            beforeEnter: (to, from, next) => {
              if (store.getters["usercase/currentUsercase"])
                store.dispatch("usercase/sponsorship/refreshCandidate");
              next();
            },
          },

          {
            path: "documents",
            components: {
              default: SponsorshipCase,
              tab: documents,
            },
            beforeEnter: (to, from, next) => {
              if (store.getters["usercase/currentUsercase"])
                store.dispatch("usercase/sponsorship/refreshDocuments");
              next();
            },
            meta: {
              auth: true,
              title: "Sponsor licence",
            },
          },

          {
            path: "online_application",
            components: {
              default: SponsorshipCase,
              tab: online_application,
            },
            meta: {
              auth: true,
              title: "Sponsor licence",
            },
          },

          // {
          //   path: ':tab',
          //   components: {
          //     default: SponsorshipCase,
          //     tab: sponsorshipCaseTabSelector,
          //   },
          //   props: {
          //     default: true,
          //     tab: route => ({ tab: route.params.tab })
          //   },
          //   meta: {
          //     auth: true,
          //     title: 'Sponsorship'
          //   }
          // }
        ],
      },
    ],
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  {
    path: "/signup_employee/:company_id",
    name: "Login employee",
    component: Login,
  },

  {
    alias: "*",
    path: "/not-found",
    name: "NotFound",
    component: NotFound,
  },
];

export default baseRoutes;
